module.exports = __webpack_public_path__ + "img/Vimkey-macOS-store-grid.1c79c7bd.png";